import {observer} from 'mobx-react';
import {Button} from 'shared/components/buttons';
import {FormattedMessage} from 'react-intl';
import {redirect} from 'shared/tools';

const InterviewAppSetupTask = observer(({uiState}) => {
  const {task} = uiState;
  const explanationKey = task.relatedAttributes.purposes.sort().join('_');

  return (
    <div>
      <div className='mb3 jumbo'>
        <FormattedMessage id={`inbox.interview_app_setup.explanation.${explanationKey}`}/>
      </div>
      {task.assignedToCurrentUser &&
        <Button onClick={() => redirect('/user_settings#scheduling_integrations')}>
          <FormattedMessage id='inbox.interview_app_setup.CALL_TO_ACTION' values={{count: task.relatedAttributes.purposes.length}}/>
        </Button>
      }
    </div>
  );
});

export default InterviewAppSetupTask;
